import React from "react";
import { Stack, HStack } from "@UI/Components/Stack/Stack";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { Icon } from "@UI/Components/Icon/Icon";
import { AngleDown } from "@UI/Components/Icons/AngleDown";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { ICandidateFilter, CandidateFilters } from "../../types";
import messages from "../messages";

interface CandidatesHeaderProps {
  title: React.ReactNode;
  countLabel?: string | number;
  filter?: ICandidateFilter;
  onFilterClick?: () => void;
  showFilter?: boolean;
}

export const CandidatesHeader: React.FC<CandidatesHeaderProps> = ({
  title,
  countLabel,
  filter,
  onFilterClick,
  showFilter,
}) => {
  return (
    <Stack
      w="full"
      flexDir={{ base: "column", md: "row" }}
      alignItems={{ base: "start", md: "center" }}
      justifyContent="space-between"
      spacing={{ base: "8px", lg: "0" }}
    >
      <Heading as="h4" fontSize={{ base: "xl", md: "3xl" }}>
        {title} {countLabel !== undefined && `(${countLabel})`}
      </Heading>

      {showFilter && onFilterClick && filter && (
        <HStack
          w={{ base: "full", md: "auto" }}
          spacing="8px"
          justifyContent="center"
          ml="5px"
        >
          <Text fontSize={{ base: "sm", md: "initial" }} m="0">
            <FormattedMessage {...messages["filterBy"]} />:
          </Text>

          <Button
            variant="outline"
            bg="white"
            borderColor="gray.400"
            color="gray.700"
            _hover={{ bg: "white", borderColor: "gray.500" }}
            flexGrow={{ base: 1, md: 0 }}
            justifyContent={"space-between"}
            rightIcon={<Icon as={AngleDown} width="16px" height="16px" />}
            onClick={onFilterClick}
          >
            <FormattedMessage
              {...messages[
                filter === CandidateFilters.last_updated
                  ? "lastUpdated"
                  : "recommended"
              ]}
            />
          </Button>
        </HStack>
      )}
    </Stack>
  );
};
